import { Button, DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutEdiEventStatusTable extends Layout {
    buttonDefaults: Button;
    sourceEdistatuseventTable: DataSource;
    tableEdiStatusEvent: Table;
}
